import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import ReceiptSection from "./ReceiptSection";

function ReceiptList({ data }) {
  const [license, setLicense] = useState([]);
  const [dues, setDues] = useState([]);
  const [chambers, setChambers] = useState([]);
  const [pupilage, setPupilage] = useState([]);
  const [conference, setConference] = useState([]);

  useEffect(() => {
    data.sort((a, b) => (a.post_type > b.post_type ? 1 : -1));

    const sortedReceipts = {
      license: [],
      dues: [],
      chambers: [],
      pupilage: [],
      conference: [],
      stickers: [],
    };

    data.forEach((obj) => {
      switch (obj.post_type) {
        case "license":
          sortedReceipts.license.push(obj);
          break;
        case "dues":
          sortedReceipts.dues.push(obj);
          break;
        case "regdues":
          sortedReceipts.dues.push(obj);
          break;
        case "chambers":
          sortedReceipts.chambers.push(obj);
          break;
        case "pupilage":
          sortedReceipts.pupilage.push(obj);
          break;
        case "conference":
          sortedReceipts.conference.push(obj);
          break;
        case "sticker":
          sortedReceipts.stickers.push(obj);
          break;
        default:
          break;
      }
    });

    setLicense(sortedReceipts.license);
    setDues(sortedReceipts.dues);
    setChambers(sortedReceipts.chambers);
    setPupilage(sortedReceipts.pupilage);
    setConference(sortedReceipts.conference);
  }, [data]);

  return (
    <>
      {data.some(item => item.post_type === "boardroom-summit") && <div className="my-8 p-6 bg-white rounded-lg"><h2 className="text-xl font-bold">Boardroom Governance Summit Receipts</h2><Link className="underline" to="/home/summit">View and print your summit receipt</Link></div>}
      {license.length > 0 && (
        <ReceiptSection name="Licence Receipts" items={license} />
      )}
      {dues.length > 0 && <ReceiptSection name="Dues Receipts" items={dues} />}
      {chambers.length > 0 && (
        <ReceiptSection name="Chambers Receipts" items={chambers} />
      )}
      {conference.length > 0 && (
        <ReceiptSection name="Conference Receipts" items={conference} />
      )}
      {pupilage.length > 0 && (
        <ReceiptSection name="Pupilage Receipts" items={pupilage} />
      )}
    </>
  );
}

export default ReceiptList;
